import React from "react";
import {
  DataGrid,
  ptBR,
  GridToolbarExport,
  GridToolbarContainer,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import "./table.css";
import Tooltip from "@mui/material/Tooltip";
import { withStyles } from "@material-ui/core";
import SmallModal from "../UI/Modals/Small";
import ViewListIcon from "@mui/icons-material/ViewList";
import ChatIcon from "@mui/icons-material/Chat";
import ListIcon from "@mui/icons-material/List";

const StyledDataGrid = withStyles({
  root: {
    "& .MuiDataGrid-renderingZone": {
      maxHeight: "none !important",
    },
    "& .MuiDataGrid-panelWrapper": {
      width: "100px",
    },
    "& .MuiDataGrid-cell": {
      lineHeight: "unset !important",
      maxHeight: "none !important",
      whiteSpace: "normal",
      fontSize: "calc(6px + 0.5vw)",
    },
    "& .MuiDataGrid-row": {
      maxHeight: "none !important",
    },
    "& .MuiDataGrid-toolbarContainer": {
      minHeight: "30px",
      maxHeight: "30px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    "& .MuiDataGrid-toolbarContainer .MuiButton-root": {
      marginLeft: "-2vh",
    },
  },
})(DataGrid);

const CustomToolbar = ({ setFilterButtonEl }) => (
  <GridToolbarContainer>
    <GridToolbarFilterButton ref={setFilterButtonEl} />
    <GridToolbarExport
      csvOptions={{ delimiter: ";" }}
      printOptions={{ disableToolbarButton: true }}
    />
  </GridToolbarContainer>
);

const columns = [
  {
    field: "data",
    headerName: "Data e Hora",
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title={new Date(params.value).toLocaleString()}>
            <span className="table-cell-truncate">
              {new Date(params.value).toLocaleString()}
            </span>
          </Tooltip>
        </div>
      );
    },
    flex: 1,
  },
  // {
  //   field: "codeMailing",
  //   headerName: "Cod. mailing",
  //   flex: 1,
  //   align: "left",
  //   renderCell: (params) => {
  //     return (
  //       <div>
  //         <Tooltip title={params.value}>
  //           <span className="table-cell-truncate contentTableCell">
  //             {params.value}
  //           </span>
  //         </Tooltip>
  //       </div>
  //     );
  //   },
  // },
  {
    field: "nameMailing",
    headerName: "Nome mailing",
    align: "left",
    headerAlign: "center",
    flex: 1,
    renderCell: (params) => {
      return params.value ? (
        <div>
          <Tooltip title={params.value}>
            <span className="table-cell-truncate">{params.value}</span>
          </Tooltip>
        </div>
      ) : (
        "-"
      );
    },
  },
  {
    field: "total",
    headerName: "Total",
    flex: 1 / 2,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title={params.value}>
            <span className="table-cell-truncate">{params.value}</span>
          </Tooltip>
        </div>
      );
    },
  },

  {
    field: "duplicado",
    headerName: "Duplicados",
    flex: 1 / 2,
    align: "center",
    renderCell: (params) => {
      return params.value ? (
        <div>
          <Tooltip title={params.value}>
            <span className="table-cell-truncate">{params.value}</span>
          </Tooltip>
        </div>
      ) : (
        <div className="text-center">0</div>
      );
    },
  },
  {
    field: "telefone invalido",
    headerName: "Tel. inválido",
    align: "center",
    flex: 1 / 2,
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title={params.value}>
            <span className="table-cell-truncate">{params.value}</span>
          </Tooltip>
        </div>
      );
    },
  },
  {
    field: "enviado dia anterior",
    headerName: "Enviado dia anterior",
    align: "center",
    flex: 1 / 2,
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title={params.value}>
            <span className="table-cell-truncate">{params.value}</span>
          </Tooltip>
        </div>
      );
    },
  },
  {
    field: "enviado",
    headerName: "Enviado",
    flex: 1 / 2,
    align: "center",
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title={params.value}>
            <span className="table-cell-truncate">{params.value}</span>
          </Tooltip>
        </div>
      );
    },
  },

  {
    field: "delivered",
    headerName: "Entregue",
    flex: 1 / 2,
    align: "center",
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title={params.value}>
            <span className="table-cell-truncate">{params.value}</span>
          </Tooltip>
        </div>
      );
    },
  },
  {
    field: "read",
    headerName: "Lido",
    align: "center",
    headerAlign: "center",
    flex: 1 / 2,
    renderCell: (params) => {
      return params.value ? (
        <div>
          <Tooltip title={params.value}>
            <span className="table-cell-truncate">{params.value}</span>
          </Tooltip>
        </div>
      ) : (
        "0"
      );
    },
  },
  {
    field: "error",
    headerName: "Erro",
    align: "center",
    headerAlign: "center",
    flex: 1 / 2,
    renderCell: (params) => {
      return params.value ? (
        <div>
          <div>
            <Tooltip title={params.value}>
              <span className="table-cell-truncate">{params.value}</span>
            </Tooltip>
          </div>
        </div>
      ) : (
        <div className="text-center">0</div>
      );
    },
  },
  {
    field: "new",
    headerName: "Novo",
    flex: 1 / 2,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <div>
        <Tooltip title={params.value}>
          <span className="table-cell-truncate">{params.value}</span>
        </Tooltip>
      </div>
    ),
  },
  {
    field: "Genesys",
    headerName: "Genesys",
    align: "center",
    headerAlign: "center",
    flex: 1 / 2,
    renderCell: (params) => {
      return params.value ? (
        <div>
          <div>
            <Tooltip title={params.value}>
              <span className="table-cell-truncate">{params.value}</span>
            </Tooltip>
          </div>
        </div>
      ) : (
        <div className="text-center">0</div>
      );
    },
  },
  {
    field: "Mensagem",
    headerName: "Mensagem",
    align: "center",
    headerAlign: "center",
    flex: 1 / 2,
    renderCell: (params) => {
      return params.value ? (
        <div>
          <div>
            <Tooltip title={params.value}>
              <span className="table-cell-truncate">{params.value}</span>
            </Tooltip>
          </div>
        </div>
      ) : (
        <div className="text-center">0</div>
      );
    },
  },
];

function transformObjects(data) {
  let arr = [];
  for (let i in data) {
    arr.push({
      ...data[i],
      codeMailing: data[i]?._id.codemailing,
      data: data[i]?._id.data,
      nameMailing: data[i]?._id.namemailing,
    });
  }

  return arr;
}
function generateDynamicId(length = 15) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let id = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    id += characters.charAt(randomIndex);
  }

  return id;
}

export default function ConsolidatedBackOffice(data) {
  const rows = transformObjects(data.data);
  return (
    <>
      <div style={{ height: "110%", width: "100%" }}>
        <StyledDataGrid
          disableSelectionOnClick
          components={{
            Toolbar: CustomToolbar,
          }}
          localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          rows={rows}
          getRowId={(row) => {
            return generateDynamicId(26);
          }}
          // @ts-ignore
          columns={columns}
        />
      </div>
    </>
  );
}
